import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CategoryState, initCategories } from './CategoryReducer';

export const selectCategoryState = createFeatureSelector<CategoryState>('category');

export const initCategoriesSelector = createSelector(
  selectCategoryState,
  initCategories
);
